import React, { Component } from 'react';
import { markdownToHtml } from '$lib/markdown';
import styles from './styles.scss';

class QuizExplanation extends Component {
  render() {
    const { quizObj } = this.props;

    const { quiz } = quizObj;
    const { explanation } = quiz;

    return <div className={styles.layout}>{markdownToHtml(explanation)}</div>;
  }
}

export default QuizExplanation;
